import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Checkbox,
  IconButton,
  Modal,
  Tooltip,
  InputLabel,
  CircularProgress,
  Typography,
  Card,
  Grid,
  CardContent,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert,
  AlertTitle,
  Link,
  FormControlLabel,
  Backdrop,
} from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import { Theme, useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { checkForRole } from "../../utils/GetAuth";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import {
  getCustomerGroups,
  getCustomers,
  saveCustomerGroup,
  deleteCustomerGroup,
} from "../../utils/RemotePriceManagement";
import { determineConfigLong } from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import LockIcon from "@mui/icons-material/Lock";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import GetApp from "@mui/icons-material/GetApp";
import Attachment from "@mui/icons-material/Attachment";
import Publish from "@mui/icons-material/Publish";
import CloseIcon from "@mui/icons-material/Close";
import RocketIcon from "@mui/icons-material/RocketLaunch";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle: {
      color: theme.palette.primary.main,
    },
    modalCard: {},
    modalText: {},
    modalInput: {
      width: "350px",
    },
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid`,
      borderColor: theme.palette.border.main,
      boxShadow: theme.shadows[4],
      padding: theme.spacing(2, 2, 2),
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      minWidth: 160,
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    card: {},
  })
);

const steps = ["Create Customer Group"];

export default function PriceChangeCustomerGroups() {
  const classes = useStyles();
  const [customerGroupData, setCustomerGroupData] = useState<any[]>([]);
  const [groupWithCustomersData, setGroupWithCustomersData] = useState<any[]>([]);
  const [customerList, setCustomerList] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [deliveringPlants, setDeliveringPlants] = React.useState<any>();
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId, salesOrg, "vp_admin");
  const [muiTable, setMuiTable] = React.useState<any>({ rpp: 25 });
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

  const [editedRowParamName, setEditedRowParamName] = React.useState<string>("");
  const [fileName, setfileName] = React.useState<string>();
  const [selectedFile, setSelectedFile] = React.useState<File>();
  //
  const [customerGroupName, setCustomerGroupName] = React.useState<string>("");
  const [comingSoonPopup, setComingSoonPopup] = React.useState<boolean>(false);
  const [rowCustomer, setRowCustomer] = useState<any>({
    searchCustomer: null,
  });
  const [bulkMessage, setBulkMessage] = React.useState<string>();
  const [bulkErrorBody, setBulkErrorBody] = React.useState<any>();
  const [bulkSummary, setBulkSummary] = React.useState<{ valid: number; invalid: number }>();
  //
  const [activeStep, setActiveStep] = React.useState(0);

  const [openCustomerDetailsPopup, setOpenCustomerDetailsPopup] = React.useState(false);
  const [customerDetailsPopupData, setCustomerDetailsPopupData] = useState<any[]>([]);
  const [updatedTableData, setUpdatedTableData] = useState<any>([]);
  const [isEditOperation, setIsEditOperation] = React.useState<boolean>(false);
  const [groupGUID, setGroupGUID] = React.useState<string>("");
  const [approvalNeeded, setApprovalNeeded] = React.useState<boolean>(false);
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  const [recoredToBeDeleted, setRecoredToBeDeleted] = React.useState<any>();
  const [modalStyle] = React.useState(getModalStyle);
  //
  const [commonAlert, setCommonAlert] = useState<any>({
    alertTitle: "",
    alertMessage: "",
    alertProceedButton: false,
    alertDenyButton: false,
    alertDisable: false,
    isAlertOpen: false,
  });

  const [disabledSaveButton, setDisabledSaveButton] = React.useState<boolean>(false);
  const [isLandingPage, setIsLandingPage] = React.useState<boolean>(true);

  const autoCompleteFilterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100, // 👈 Restricts the DOM to render a max of 100 items at a time
  });

  const groupByCustomerGroups = (customerGroupData: any) => {
    const outputWithCounts: any = Object.values(
      customerGroupData.reduce((acc: any, item: any) => {
        const key = item.group_guid;

        if (!acc[key]) {
          acc[key] = {
            client_id: item?.client_id,
            sales_org: item?.sales_org,
            group_guid: key,
            group_name: item?.group_name,
            need_approval: item?.require_approval,
            customer_count: 0,
            customerList: [],
          };
        }

        acc[key].customer_count++;
        acc[key].customerList.push({ customer_num: item?.customer_num, customer_name: item?.customer_name });

        return acc;
      }, {})
    );
    //
    return outputWithCounts;
  };

  useEffect(() => {
    if (doneLoading) return;
    //Implement API calling to get list of price change request
    getCustomerGroups(salesOrg)
      .then((response: any) => {
        if (response) {
          setDoneLoading(true);
          setGroupWithCustomersData(response);
          const customerGroupList: any = groupByCustomerGroups(response);
          setCustomerGroupData(customerGroupList);
          setIsLandingPage(true);
        }
      })
      .catch(() => {
        setDoneLoading(true);
      });
  }, [doneLoading, customerGroupData, salesOrg]);

  useEffect(() => {
    getCustomers(salesOrg)
      .then((response: any) => {
        if (response) {
          setCustomerList(response);
        }
      })
      .catch(() => setDoneLoading(true));
  }, [salesOrg]);

  useEffect(() => {
    if (customerGroupName != "" && updatedTableData.length) {
      setDisabledSaveButton(false);
    } else {
      setDisabledSaveButton(true);
    }
  }, [customerGroupName, updatedTableData]);

  //**************

  const handleDelete = () => {
    const payloadToSave: any = {
      groupName: recoredToBeDeleted?.group_name,
      groupGuid: recoredToBeDeleted?.group_guid,
    };
    setBackdropLoader(true);
    deleteCustomerGroup(salesOrg, payloadToSave).then((response: any) => {
      if (response && response?.status > 200) {
        const alert = {
          alertTitle: "Customer Group Alert",
          alertMessage: response?.data?.message,
          isAlertOpen: true,
          alertProceedButton: false,
          alertDenyButton: false,
          alertDisable: false,
        };
        setCommonAlert(alert);
        setBackdropLoader(false);
        return;
      }
      //
      if (response && response?.data?.result) {
        setTimeout(() => {
          handleModalClose();
          setDoneLoading(false);
        }, 1000);
      }
    });
  };

  const handleEdit = (tableRow: any) => {
    //
    const foundGroupDetails: any = groupWithCustomersData.filter((ele: any) => ele.group_guid == tableRow?.group_guid);
    if (foundGroupDetails && foundGroupDetails.length) {
      setCustomerGroupName(tableRow?.group_name);
      setApprovalNeeded(tableRow?.need_approval);
      setGroupGUID(tableRow?.group_guid);
      const updatedTableData: any = foundGroupDetails.map((ele: any) => {
        return {
          clientId: ele?.client_id,
          salesOrg: ele?.sales_org,
          customerNum: ele?.customer_num,
          customerName: ele?.customer_name,
        };
      });

      setUpdatedTableData([...updatedTableData]);
      setIsLandingPage(false);
      setActiveStep(0);
    }
  };

  const handleModalClose = () => {
    setUpdatedTableData([]);
    setEditedRowParamName("");
    setIsEditOperation(false);
    setGroupGUID("");
    setCustomerDetailsPopupData([]);
    setOpenCustomerDetailsPopup(false);
    setApprovalNeeded(false);
    setBackdropLoader(false);
  };

  const handleModalSave = () => {
    const payloadToSave: any = {
      groupName: customerGroupName,
      groupCustomersObject: updatedTableData,
      operationType: isEditOperation ? "edit" : "save",
      approvalNeeded: approvalNeeded,
      groupGuid: groupGUID,
    };
    setBackdropLoader(true);
    saveCustomerGroup(salesOrg, payloadToSave).then((response: any) => {
      if (response && response?.status > 200) {
        const alert = {
          alertTitle: "Customer Group Alert",
          alertMessage: response?.data?.message,
          isAlertOpen: true,
          alertProceedButton: false,
          alertDenyButton: false,
          alertDisable: false,
        };

        setCommonAlert(alert);
        return;
      }
      //
      if (response && response?.data?.result) {
        setCustomerGroupData([]);
        setTimeout(() => {
          handleModalClose();
          setDoneLoading(false);
        }, 1000);
      }
    });
  };

  const handleAddDataToTable = () => {
    //handling duplicate group
    const duplicateItem: any = updatedTableData.find(
      (ele: any) => ele?.customerNum == rowCustomer.searchCustomer?.customer_num
    );
    if (duplicateItem) {
      const alert = {
        alertTitle: "Customer Group Alert",
        alertMessage: `Not Allowed! You are trying to add duplicate Customer ${duplicateItem?.customerNum}`,
        isAlertOpen: true,
        alertProceedButton: false,
        alertDenyButton: false,
        alertDisable: false,
      };

      setCommonAlert(alert);
      return;
    }

    const newItemAdded: any = {
      clientId: rowCustomer.searchCustomer?.client_id,
      salesOrg: rowCustomer?.searchCustomer?.sales_org,
      customerNum: rowCustomer.searchCustomer?.customer_num,
      customerName: rowCustomer.searchCustomer?.customer_name,
    };
    const updatedData: any = [...updatedTableData, { ...newItemAdded }];
    setUpdatedTableData(updatedData);
  };

  return (
    <>
      <div className={classes.root}>
        {isLandingPage ? (
          <div className={classes.root}>
            {doneLoading && enabled ? (
              <TableAbstraction
                settingsKey="ADM_OPT"
                options={{
                  draggableColumns: {
                    enabled: true,
                  },
                  rowsPerPageOptions: [25, 50, 100],
                  serverSide: false,
                  selectableRows: "none",
                  rowsPerPage: muiTable.rpp,
                  onChangeRowsPerPage: (numberOfRows) => {
                    muiTable.rpp = numberOfRows;
                    setMuiTable(muiTable);
                  },
                  customToolbar: () => {
                    return (
                      <Tooltip title={`Add Customer Groups`}>
                        <IconButton
                          onClick={() => {
                            handleModalClose();
                            setCustomerGroupName("");
                            setIsLandingPage(false);
                            setActiveStep(0);
                          }}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    );
                  },
                }}
                columns={[
                  {
                    label: "Customer Group",
                    name: "group_name",
                    options: {
                      filter: true,
                      renderCell: (params) => (
                        <Link
                          component="button"
                          onClick={() => {
                            const foundCustomerGroup: any = customerGroupData.find(
                              (ele: any) => ele?.group_guid.trim() == params?.row.group_guid?.trim()
                            );

                            setCustomerDetailsPopupData(foundCustomerGroup?.customerList);
                            setOpenCustomerDetailsPopup(true);
                          }}
                        >
                          {params.value}
                        </Link>
                      ),
                    },
                  },
                  {
                    label: "Need Approval",
                    name: "need_approval",
                    options: {
                      filter: true,
                    },
                  },
                  {
                    label: "Customers",
                    name: "customer_count",
                  },
                  {
                    label: "Action",
                    name: "action",
                    options: {
                      filter: false,
                      renderCell: (params) => {
                        return (
                          <React.Fragment>
                            <Tooltip title={"Delete"}>
                              <DeleteIcon
                                sx={{ cursor: "pointer" }}
                                fontSize="small"
                                onClick={() => {
                                  setRecoredToBeDeleted(params.row);
                                  setConfirmDelete(true);
                                }}
                              />
                            </Tooltip>
                            <Tooltip title={"Edit"}>
                              <EditIcon
                                sx={{ cursor: "pointer", marginLeft: 2 }}
                                fontSize="small"
                                onClick={() => {
                                  setIsEditOperation(true);
                                  handleEdit(params.row);
                                }}
                              />
                            </Tooltip>
                          </React.Fragment>
                        );
                      },
                    },
                  },
                ]}
                data={customerGroupData}
              />
            ) : enabled ? (
              <div className={classes.centerDiv}>
                <CircularProgress color="primary" />
              </div>
            ) : (
              <Alert severity="error">
                <AlertTitle>
                  <LockIcon /> Access Error
                </AlertTitle>
                You do not currently have access to <strong>Admin</strong> activities for the{" "}
                <strong>{salesOrg}</strong> bottler.
              </Alert>
            )}
          </div>
        ) : (
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#fff",
              boxSizing: "border-box",
              p: 3,
            }}
          >
            <Stepper nonLinear activeStep={activeStep}>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepButton aria-controls="stepper-content" color="inherit">
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
            <div id="stepper-content">
              <React.Fragment>
                {activeStep === 0 ? (
                  <>
                    <Grid container spacing={2} className={classes.modalGrid}>
                      <Grid item xl={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.modalText}
                          paragraph
                          dangerouslySetInnerHTML={{
                            __html: determineConfigLong(codes, "optimization_param", editedRowParamName),
                          }}
                        ></Typography>
                        <Card className={classes.modalCard}>
                          <CardContent>
                            <Grid container spacing={1} className={classes.modalGrid}>
                              <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                                <InputLabel>Group Name</InputLabel>
                                <TextField
                                  sx={{ marginTop: "15px" }}
                                  placeholder="Group Name"
                                  helperText="Enter Group Name"
                                  type="text"
                                  style={{ width: "450px" }}
                                  className={classes.modalInput}
                                  value={customerGroupName}
                                  onChange={(e) => {
                                    setCustomerGroupName(
                                      e.target.value && typeof e.target.value == "string" ? e.target.value : ""
                                    );
                                  }}
                                ></TextField>
                              </Grid>
                              <Grid item xs={"auto"} md={"auto"} xl={"auto"} marginLeft={5}>
                                <InputLabel>Customer</InputLabel>
                                <Autocomplete
                                  options={customerList}
                                  style={{ width: "450px" }}
                                  filterOptions={autoCompleteFilterOptions}
                                  value={rowCustomer.searchCustomer}
                                  getOptionLabel={(option: any) => `${option?.customer_num}- ${option?.customer_name}`}
                                  onChange={(_, newCust) => {
                                    setRowCustomer({
                                      ...rowCustomer,
                                      searchCustomer: newCust,
                                    });
                                    // setEditedRowMaterialNum((newMat&&  typeof newMat== 'string') ? newMat: "*");
                                  }}
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter" && (event.target as any).value) {
                                      const newCust = (event.target as any).value;
                                      setRowCustomer({ ...rowCustomer, searchCustomer: newCust });
                                      // setEditedRowMaterialNum((newMat&&  typeof newMat== 'string') ? newMat: "*");
                                    }
                                  }}
                                  //  disabled={!editedRowMaterialNum}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Search Customers"
                                      helperText="Select Customers to be added"
                                      variant="standard"
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={"auto"} md={"auto"} xl={"auto"} marginLeft={5} marginTop={5}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      value="my-custom-value"
                                      checked={approvalNeeded}
                                      onChange={(event: any) => {
                                        setApprovalNeeded(event.target.checked);
                                      }}
                                    />
                                  }
                                  label="Need Approval"
                                />
                              </Grid>
                              <Grid item xs={"auto"} md={"auto"} xl={"auto"} marginLeft={10} marginTop={3}>
                                <Button
                                  color="primary"
                                  variant="contained"
                                  className={classes.paragraphButton}
                                  style={{ width: "130px" }}
                                  onClick={handleAddDataToTable}
                                >
                                  + Add
                                </Button>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              spacing={1}
                              className={classes.modalGrid}
                              marginTop={2}
                              sx={{ display: "none" }}
                            >
                              <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                                <Button
                                  color="primary"
                                  variant="contained"
                                  className={classes.paragraphButton}
                                  onClick={(event) => {
                                    // Feature downloadPriceGroupCSV is implemeted, but it will be improved further till then
                                    //a message will be shown as Coming Soon and return;
                                    setComingSoonPopup(true);
                                    return;
                                  }}
                                >
                                  <GetApp /> Get Template
                                </Button>
                              </Grid>
                              <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                                <Button
                                  color="primary"
                                  component="label"
                                  variant="contained"
                                  className={classes.paragraphButton}
                                  onClick={(event: any) => {
                                    // Temporaray onclick event to just show the coming soon message
                                    //once feature is furtehr improved remove this onclick.
                                    setComingSoonPopup(true);
                                    event.preventDefault();
                                    return;
                                  }}
                                >
                                  <Attachment style={{ marginRight: 3 }} /> Select File
                                  <input
                                    type="file"
                                    name="banks"
                                    id="bank-file"
                                    hidden
                                    onChange={(e) => {
                                      setSelectedFile(undefined);
                                      if (e.target.files) {
                                        setSelectedFile(e.target.files[0]);
                                        setfileName(e.target.files[0].name);
                                        e.target.value = "";
                                      }
                                    }}
                                  />
                                </Button>
                                <TextField
                                  sx={{ marginLeft: "20px", marginTop: "15px", width: "180px" }}
                                  placeholder="File"
                                  type="text"
                                  value={fileName}
                                />
                                <Button
                                  color="primary"
                                  variant="contained"
                                  className={classes.paragraphButton}
                                  style={{ marginLeft: "20px" }}
                                  disabled={selectedFile ? false : true}
                                  onClick={(event) => {}}
                                >
                                  <Publish /> Upload
                                </Button>
                              </Grid>
                              {bulkMessage && !bulkErrorBody /* Upload Detected */ ? (
                                <Grid item xs={"auto"} md={"auto"} xl={"auto"} marginLeft={40} height={40} width={70}>
                                  <Card>
                                    <CardContent>
                                      <Box display="flex" alignItems="center" gap={2}>
                                        <div>
                                          <Typography variant="h6" className={classes.paragraph}>
                                            Approve Changes
                                          </Typography>
                                          <Typography variant="subtitle1" className={classes.paragraphAct} paragraph>
                                            {bulkMessage}
                                          </Typography>
                                        </div>
                                        <Alert severity="warning">
                                          <AlertTitle>Price Group Creation Summary</AlertTitle>
                                          <p>Valid: {bulkSummary?.valid}</p>
                                          <p>Invalid: {bulkSummary?.invalid}</p>
                                        </Alert>
                                      </Box>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              ) : bulkMessage && bulkErrorBody ? (
                                <Grid item xl={"auto"} marginLeft={40} height={40}>
                                  <Card className={classes.card}>
                                    <CardContent>
                                      <Box display="flex" alignItems="center" gap={2}>
                                        <div>
                                          <Typography variant="h6" className={classes.paragraph}>
                                            Could not process file
                                          </Typography>
                                          <Alert severity="error">
                                            <AlertTitle>Error</AlertTitle>
                                            {bulkMessage}
                                          </Alert>
                                        </div>
                                        {bulkErrorBody.duplicatePriceGroup ? (
                                          <div style={{ marginTop: "45px;" }}>
                                            <Alert severity="warning">
                                              <AlertTitle>Duplicate Price Group</AlertTitle>
                                              {bulkErrorBody.duplicatePriceGroup.join(", ")}
                                            </Alert>
                                          </div>
                                        ) : (
                                          <div></div>
                                        )}
                                      </Box>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              ) : (
                                <div></div>
                              )}
                            </Grid>
                            <div className={classes.root} style={{ marginTop: 10 }}>
                              <TableAbstraction
                                settingsKey="ADM_BN"
                                options={{
                                  draggableColumns: {
                                    enabled: true,
                                  },
                                  serverSide: false,
                                  selectableRows: "none",
                                  tableBodyHeight:"480px",
                                }}
                                title="Custom Group Data Set"
                                columns={[
                                  // salesOffice:string, bankID: string, bankName: string, customerNum:string, change:string
                                  {
                                    label: "Customer Number",
                                    name: "customerNum",
                                    options: {
                                      filter: true,
                                    },
                                  },
                                  {
                                    label: "Customer Name",
                                    name: "customerName",
                                    options: {
                                      filter: true,
                                    },
                                  },
                                  //Commenting temporarly as import price grup functionality is coming up
                                  //This section is usefull for that functionality
                                  // {
                                  //   label: "Valid",
                                  //   name: "valid",
                                  //   options: {
                                  //     searchable: true,
                                  //     filter: true,
                                  //     customBodyRender: (value: any) => {
                                  //       return value === "Yes" ? (
                                  //         <AddCircle style={{ color: "Green" }} />
                                  //       ) : (
                                  //         <RemoveCircle style={{ color: "Red" }} />
                                  //       );
                                  //     },
                                  //   },
                                  // },
                                  {
                                    label: "Action",
                                    name: "action",
                                    options: {
                                      filter: false,
                                      renderCell: (params) => {
                                        return (
                                          <React.Fragment>
                                            <Tooltip title={"Delete"}>
                                              <DeleteIcon
                                                sx={{ cursor: "pointer" }}
                                                fontSize="small"
                                                onClick={() => {
                                                  let updatedData: any = updatedTableData.filter(
                                                    (ele: any) =>
                                                      ele.customerNum.trim() != params.row?.customerNum.trim()
                                                  );
                                                  setUpdatedTableData(updatedData);
                                                }}
                                              />
                                            </Tooltip>
                                          </React.Fragment>
                                        );
                                      },
                                    },
                                  },
                                ]}
                                data={updatedTableData}
                              />
                            </div>
                          </CardContent>
                        </Card>
                        {/* <div style={{ paddingRight: "5px", textAlign: "right" }}>
                    <React.Fragment>
                      <Tooltip title={"Save"}>
                        <IconButton disabled={disabledSaveButton} color="primary" onClick={handleModalSave}>
                          <SaveIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={"Cancel"}>
                        <IconButton color="primary" onClick={handleModalClose}>
                          <Clear />
                        </IconButton>
                      </Tooltip>
                    </React.Fragment>
                  </div> */}
                      </Grid>
                    </Grid>

                    <div style={{ paddingRight: "5px", textAlign: "right", marginTop: 10 }}>
                      <React.Fragment>
                        <Button
                          variant="contained"
                          disabled={disabledSaveButton}
                          color="primary"
                          onClick={handleModalSave}
                        >
                          Save
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            handleModalClose();
                            setIsLandingPage(true);
                          }}
                        >
                          Cancel
                        </Button>
                      </React.Fragment>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </React.Fragment>
            </div>
          </Box>
        )}

        {/** Customer details popup model*/}
        <Modal open={openCustomerDetailsPopup} onClose={handleModalClose}>
          <div style={modalStyle} className={classes.paper}>
            <IconButton
              aria-label="close"
              onClick={() => {
                handleModalClose();
              }}
              sx={{ position: "absolute", right: 16, top: 16, color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
            <Grid container spacing={2} className={classes.modalGrid} marginTop={5}>
              <Grid item xs={12}>
                <Card>
                  <TableAbstraction
                    settingsKey="ADM_BN"
                    options={{
                      draggableColumns: {
                        enabled: true,
                      },
                      serverSide: false,
                      selectableRows: "none",
                    }}
                    title="Customer Details"
                    columns={[
                      {
                        label: "Customer Number",
                        name: "customer_num",
                        options: {
                          filter: true,
                        },
                      },
                      {
                        label: "Customer Name",
                        name: "customer_name",
                        options: {
                          filter: true,
                        },
                      },
                    ]}
                    data={customerDetailsPopupData}
                  />
                </Card>
              </Grid>
            </Grid>
          </div>
        </Modal>

        <Dialog
          open={comingSoonPopup}
          onClose={() => {
            setComingSoonPopup(false);
          }}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 4,
              padding: 2,
              textAlign: "center",
              position: "relative",
              overflow: "visible", // Allows visual elements to slightly overlap if needed
            },
          }}
        >
          {/* Close Button top-right */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setComingSoonPopup(false);
            }}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent sx={{ pt: 4, pb: 2 }}>
            {/* Animated/Styled Icon Container */}
            <Box
              sx={{
                display: "inline-flex",
                backgroundColor: "primary.lightest", // Customize with your theme values
                bgcolor: "action.hover",
                p: 3,
                borderRadius: "50%",
                mb: 3,
              }}
            >
              <RocketIcon sx={{ fontSize: 50, color: "primary.main" }} />
            </Box>

            {/* Heading & Copy */}
            <Typography variant="h5" component="h2" fontWeight="700" gutterBottom>
              Feature Coming Soon!
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4, px: 2 }}>
              We are hard at work building this feature to improve your experience.
            </Typography>
          </DialogContent>
        </Dialog>

        {/* Page common alert message popup */}
        <Dialog open={commonAlert.isAlertOpen} onClose={() => setCommonAlert({ ...commonAlert, isAlertOpen: false })}>
          <DialogTitle>{commonAlert.alertTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText>{commonAlert.alertMessage}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setCommonAlert({ ...commonAlert, isAlertOpen: false });
              }}
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete confirmation popup */}
        <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you would like to delete Price Group: {recoredToBeDeleted?.group_name}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleDelete();
                setConfirmDelete(false);
              }}
              color="primary"
            >
              Yes
            </Button>
            <Button
              onClick={() => {
                setRecoredToBeDeleted(undefined);
                setConfirmDelete(false);
              }}
              color="primary"
              autoFocus
            >
              No
            </Button>
          </DialogActions>
        </Dialog>

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
          }}
          open={backdropLoader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
}
